const LEVELS = { error: 0, warn: 1, info: 2, debug: 3 } as const;
type Level = keyof typeof LEVELS;

const configuredLevel: Level =
  (import.meta.env.VITE_LOG_LEVEL as Level) ||
  (import.meta.env.PROD ? "warn" : "debug");

function shouldLog(level: Level): boolean {
  return LEVELS[level] <= LEVELS[configuredLevel];
}

type LogArgs =
  | [msg: string, ...args: unknown[]]
  | [context: Record<string, unknown>, msg: string];

function format(args: LogArgs): [string, ...unknown[]] {
  if (typeof args[0] === "string") return args as [string, ...unknown[]];
  const [ctx, msg] = args as [Record<string, unknown>, string];
  return [`${msg} ${JSON.stringify(ctx)}`];
}

export const logger = {
  error: (...args: LogArgs) => {
    if (shouldLog("error")) console.error("[ERROR]", ...format(args));
  },
  warn: (...args: LogArgs) => {
    if (shouldLog("warn")) console.warn("[WARN]", ...format(args));
  },
  info: (...args: LogArgs) => {
    if (shouldLog("info")) console.info("[INFO]", ...format(args));
  },
  debug: (...args: LogArgs) => {
    if (shouldLog("debug")) console.debug("[DEBUG]", ...format(args));
  },
};
